export enum IPVerificationStatus {
  OK = 2,
  UNREACHABLE = 0,
  WAIT_TO_CHECK = 1,
  TEXT_RUNNING = 100
}
